module.exports = __webpack_public_path__ + "img/493.51bd0150.jpg";